import React, { useEffect, useState } from 'react';
import '../../../../styles/globals.css'
import { Box, Button, Checkbox, Grid, TextField, Typography, Modal } from '@mui/material'

import { useKarmaPoolContext } from '../../../../state/KarmaPoolContext';
import { Link } from 'react-router-dom';

function MusicDurationComponent({ selectedDuration, onDurationChange }) {
    return (

        <Grid container spacing={0} sx={{ maxWidth: "30.0rem" }}>
            <Grid item xs={12} sm={12} sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Box>
                    <Typography variant="body2" component="div" gutterBottom>
                        note expires in: 48 hrs
                    </Typography>
                </Box>
            </Grid>
        </Grid>
    );
}

function NoteDurationCheckbox({ selectedDuration, onDurationChange }) {

    return (
        <Grid container spacing={0} sx={{ maxWidth: "30.0rem" }}>
            <Grid item xs={12} sm={3.9} sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Box>
                    <Typography variant="body2" component="div" gutterBottom>
                        note expires in:
                    </Typography>
                </Box>
            </Grid>
            <Grid item xs={4} sm={2.7} sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", marginTop: { xs: "0.5rem", sm: "0.0rem" } }}>
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Typography variant="body2" component="div" gutterBottom>
                        1 hr
                    </Typography>
                    <Checkbox
                        sx={{ color: 'white' }}
                        checked={selectedDuration === 1}
                        onChange={() => onDurationChange(1)}
                    />
                </Box>
            </Grid>
            <Grid item xs={4} sm={2.7} sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", marginTop: { xs: "0.5rem", sm: "0.0rem" } }}>
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Typography variant="body2" component="div" gutterBottom>
                        8 hrs
                    </Typography>
                    <Checkbox
                        sx={{ color: 'white' }}
                        checked={selectedDuration === 8}
                        onChange={() => onDurationChange(8)}
                    />
                </Box>
            </Grid>
            <Grid item xs={4} sm={2.7} sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", marginTop: { xs: "0.5rem", sm: "0.0rem" } }}>
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Typography variant="body2" component="div" gutterBottom>
                        24 hrs
                    </Typography>
                    <Checkbox
                        sx={{ color: 'white' }}
                        checked={selectedDuration === 24}
                        onChange={() => onDurationChange(24)}
                    />
                </Box>
            </Grid>
        </Grid>
    );
}

function MusicNoteSubmissionComponent(props) {

    const karmaContext = useKarmaPoolContext();

    const [noteText, setNoteText] = useState(() => {
        return "";
    });

    const handleNoteTextChange = (event) => {
        setNoteText(event.target.value);
    };

    const [selectedDuration, setSelectedDuration] = useState(48);

    const [isMember, setIsMember] = useState(false);

    useEffect(() => {
        setIsMember(karmaContext.local.user.member);
    }, [karmaContext.local.user]);

    const handleDurationChange = (duration) => {
        setSelectedDuration(duration);
    };

    const handleSubmit = (event) => {
        // Prevent page reload
        event.preventDefault();

        let urlToUse = "";

        if (noteText.includes("youtu") && (noteText.includes("?v=") || noteText.includes("youtu.be"))) {
            urlToUse = noteText;
        }
        else if (noteText.includes("spotify.com")) {
            urlToUse = noteText;
        }
        else {
            return;
        }

        karmaContext.noteManager.postNote({
            text: noteText,
            url: urlToUse,
            noteType: "MUSIC_NOTE",
            durationMinutes: selectedDuration * 60,
            moodTags: [Math.floor(Math.random() * 9) + 1, Math.floor(Math.random() * 9) + 1, Math.floor(Math.random() * 9) + 1],
        });

        props.resetNoteChoice();
    }

    return (
        <Modal open={true} sx={{ marginTop: "12rem", width: "100%", height: "100%", display: "flex", justifyContent: "center", backgroundColor: "rgba(0, 0, 0, 0.325)" }}>
            <Box sx={{ marginBottom: "0.05rem",
                width: "100%" }}>
                <Box sx={{
                    width: "100%", display: "flex", justifyContent: "center"
                }}>
                    <Box sx={{
                        backgroundColor: "rgba(0, 0, 0, 1.00)",
                        borderRadius: "0.25rem",
                        borderColor: "rgba(221, 221, 221, 0.25)",
                        border: "1px solid rgba(221, 221, 221, 0.35)",
                        padding: "1rem",
                        margin: "1rem",
                        width: "26rem"
                    }}>
                        <Box sx={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "0.35rem" }} >
                            <Typography variant="body2" component="div" gutterBottom>
                                <strong> Submit a Music Note </strong>
                            </Typography>
                        </Box>
                        <Box sx={{ marginTop: "0.625rem", width: "100%", display: "flex", justifyContent: "center" }}>
                            <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                                <div>
                                    <Box sx={{}}>
                                        <TextField
                                            fullWidth
                                            sx={{
                                                backgroundColor: "rgba(221, 221, 221, 0.0825)",
                                                margin: "0.25rem",
                                                width: "18rem", input: { color: 'white' },
                                                label: { color: 'white' }
                                            }}
                                            id="noteText"
                                            placeholder={"Enter a youtube or spotify link."}
                                            onChange={handleNoteTextChange}
                                            InputLabelProps={{ shrink: true }}
                                            value={noteText}
                                        />
                                    </Box>
                                    <Box sx={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "1.0rem", marginBottom: "0.25rem" }}>
                                        <Box sx={{ width: { xs: "82.5%", sm: "90%" }, maxWidth: "28rem", display: "flex", justifyContent: "center" }}>
                                            <MusicDurationComponent
                                                selectedDuration={selectedDuration}
                                                onDurationChange={handleDurationChange}
                                            />
                                        </Box>
                                    </Box>
                                    <SubmitOrCancelNoteComponent {...props} />
                                </div>
                            </form>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Modal >
    );
}

function NoteSubmissionComponent(props) {

    const karmaContext = useKarmaPoolContext();

    const [noteText, setNoteText] = useState(() => {
        return "";
    });

    const handleNoteTextChange = (event) => {
        setNoteText(event.target.value);
    };

    const [selectedDuration, setSelectedDuration] = useState(24);

    const handleDurationChange = (duration) => {
        setSelectedDuration(duration);
    };

    const handleSubmit = (event) => {
        // Prevent page reload
        event.preventDefault();

        let urlToUse = "";

        if ((noteText.includes("youtube") || noteText.includes("youtu.be")) && noteText.includes("?v=")) {
            urlToUse = noteText;
        }

        if (noteText.includes("spotify.com")) {
            urlToUse = noteText;
        }

        karmaContext.noteManager.postNote({
            text: noteText,
            noteType: "NOTE",
            url: urlToUse,
            durationMinutes: selectedDuration * 60
        });

        props.resetNoteChoice();
    }

    return (
        <Modal open={true} sx={{ marginTop: "12rem", width: "100%", height: "100%", display: "flex", justifyContent: "center", backgroundColor: "rgba(0, 0, 0, 0.325)" }}>
            <Box sx={{
                marginBottom: "0.05rem",
                width: "100%"
            }}>
                <Box sx={{
                    width: "100%", display: "flex", justifyContent: "center"
                }}>
                    <Box sx={{
                        backgroundColor: "rgba(0, 0, 0, 1.00)",
                        borderRadius: "0.25rem",
                        borderColor: "rgba(221, 221, 221, 0.25)",
                        border: "1px solid rgba(221, 221, 221, 0.35)",
                        padding: "1rem",
                        margin: "1rem",
                        width: "26rem"
                    }}>
                        <Box sx={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "0.35rem" }}>
                            <Typography variant="body2" component="div" gutterBottom>
                                <strong> Submit a Text Note </strong>
                            </Typography>
                        </Box>
                        <Box sx={{ marginTop: "0.625rem", width: "100%", display: "flex", justifyContent: "center" }}>
                            <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                                <div>
                                    <Box sx={{}}>
                                        <TextField
                                            fullWidth
                                            sx={{
                                                backgroundColor: "rgba(221, 221, 221, 0.0825)",
                                                margin: "0.25rem",
                                                width: "18rem", input: { color: 'white' },
                                                label: { color: 'white' }
                                            }}
                                            id="noteText"
                                            placeholder={"Enter your note here."}
                                            onChange={handleNoteTextChange}
                                            InputLabelProps={{ shrink: true }}
                                            value={noteText}
                                        />
                                    </Box>
                                    <Box sx={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "1.0rem", marginBottom: "0.25rem" }}>
                                        <Box sx={{ width: { xs: "82.5%", sm: "90%" }, maxWidth: "28rem", display: "flex", justifyContent: "center" }}>
                                            <NoteDurationCheckbox
                                                selectedDuration={selectedDuration}
                                                onDurationChange={handleDurationChange}
                                            />
                                        </Box>
                                    </Box>

                                    <SubmitOrCancelNoteComponent {...props} />
                                </div>
                            </form>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Modal>
    );
}

function SubmitOrCancelNoteComponent(props) {
    return (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "0.425rem", marginBottom: "0.25rem" }}>
            <Button
                type="submit"
                variant="contained"
                color="info"
                sx={{ backgroundColor: 'rgba(232, 232, 232, 0.5)', marginTop: "1.0rem", marginBottom: "0.75rem" }}>
                Submit
            </Button>
            <Typography variant="body2" component="div" gutterBottom sx={{ color: "#ff0204", paddingTop: "1.275rem", paddingLeft: "1rem" }}>
                <Link href="#" onClick={props.resetNoteChoice} underline="hover">
                    [ cancel ]
                </Link>
            </Typography>
        </Box>
    );
}

function NoteChoiceComponent() {

    const karmaContext = useKarmaPoolContext();

    const [noteChoice, setNoteChoice] = useState("NONE");

    const handleText = (event) => {
        // Prevent page reload
        event.preventDefault();

        if (!isMember) {
            alert("Become a member to say your mind.")
            return;
        }

        setNoteChoice("TEXT")
    }

    const handleMusic = (event) => {
        // Prevent page reload
        event.preventDefault();

        if (!isMember) {
            alert("Become a member to share music.")
            return;
        }

        setNoteChoice("MUSIC")
    }

    const resetNoteChoice = () => {
        setNoteChoice("NONE")
    }

    const [isMember, setIsMember] = useState(false);

    useEffect(() => {
        setIsMember(karmaContext.local.user.member);
    }, [karmaContext.local.user]);

    return (
        <Box sx={{ marginBottom: "0.05rem" }}>
            <>
                <Typography variant="body2" component="div" gutterBottom>
                    <strong> Submit a Note </strong>
                </Typography>
                <Box>
                    <div>
                        <Button
                            type="submit"
                            variant="contained"
                            color="info"
                            onClick={handleMusic}
                            sx={{ backgroundColor: 'rgba(232, 232, 232, 0.5)', marginTop: "1.0rem", marginBottom: "0.75rem", margin: "0.5rem" }}>
                            Music
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            color="info"
                            onClick={handleText}
                            sx={{ backgroundColor: 'rgba(232, 232, 232, 0.5)', marginTop: "1.0rem", marginBottom: "0.75rem", margin: "0.5rem" }}>
                            Text
                        </Button>
                    </div>
                </Box>
                {noteChoice === "TEXT" ? <NoteSubmissionComponent resetNoteChoice={resetNoteChoice} /> : <></>}
                {noteChoice === "MUSIC" ? <MusicNoteSubmissionComponent resetNoteChoice={resetNoteChoice} /> : <></>}
            </>

        </Box>
    );
}

export default NoteChoiceComponent;